import { useOutletContext } from 'react-router-dom'

import type { TrainingsTrainingFile } from 'generated/resources/graphql'

export const useTrainingFilesContext = () =>
  useOutletContext<{ trainingFiles: TrainingsTrainingFile[] }>()

export type TrainingFile = TrainingsTrainingFile
